import { render, staticRenderFns } from "./carInsurance.vue?vue&type=template&id=72741cf5&scoped=true"
import script from "./carInsurance.vue?vue&type=script&lang=js"
export * from "./carInsurance.vue?vue&type=script&lang=js"
import style0 from "./carInsurance.vue?vue&type=style&index=0&id=72741cf5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72741cf5",
  null
  
)

export default component.exports